import type { FC } from 'react'
import { Button } from '@mui/material'
import PriorityIcon from './PriorityIcon'
import type { Theme } from '@mui/material'
import type { SystemStyleObject } from '@mui/system'
import { RED } from '~/shared/lib/theme'

const filled = (color: string): SystemStyleObject<Theme> => ({
  backgroundColor: color,
  color: 'common.white',
  '&:hover': { backgroundColor: color },
})

const DEFAULT_PRIORITY_SX: SystemStyleObject<Theme> = {
  border: '0.1rem solid',
  borderColor: 'grey.200',
  '&:hover': { backgroundColor: 'transparent' },
}

// Indexed by the numeric priority the API stores.
const PRIORITY_SX: Record<number, SystemStyleObject<Theme>> = {
  0: DEFAULT_PRIORITY_SX,
  1: filled('#F58220'),
  2: filled(RED),
}

interface PriorityToggleProps {
  priority: number
  onChange: (priority: number) => void
}

const PriorityToggle: FC<PriorityToggleProps> = props => {
  const { onChange, priority } = props

  return (
    <Button
      size="small"
      sx={[
        {
          borderTopRightRadius: '50px',
          borderBottomRightRadius: '50px',
          minWidth: 0,
          border: '0.1rem solid transparent',
        },
        PRIORITY_SX[priority] ?? DEFAULT_PRIORITY_SX,
      ]}
      onClick={() => onChange((priority + 1) % 3)}
    >
      <PriorityIcon level={priority} variant="button" />
    </Button>
  )
}

export default PriorityToggle
